const menuTriggers = [...document.querySelectorAll('.js-nav-trigger')];
const menu = document.querySelector('.js-navigation');
const menuSubTrigger = [...document.querySelectorAll('.js-navigation-sub-trigger')];

menuTriggers.map(trigger => {
    trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        menu.classList.toggle('open');
        document.body.classList.toggle('menu-open');
    });
});

// Close menu when clicking outside
document.addEventListener('click', (e) => {
    if (menu && menu.classList.contains('open')) {
        // Check if click is outside menu and triggers
        const isClickInsideMenu = menu.contains(e.target);
        const isClickOnTrigger = menuTriggers.some(trigger => trigger.contains(e.target));

        if (!isClickInsideMenu && !isClickOnTrigger) {
            menu.classList.remove('open');
            document.body.classList.remove('menu-open');
        }
    }
});

menuSubTrigger.map(trigger => {
    trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        trigger.classList.toggle('open');
    });
});
